
















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";
// @ts-ignore
import VueDPlayer from "vue-dplayer";

import "vue-dplayer/dist/vue-dplayer.css";

@Component({
  components: {
    "d-player": VueDPlayer
  }
})
export default class extends Mixins(MyForm) {
  @Prop() videoUrl!: string;

  options: any = {
    video: {
      url: ""
    }
  };

  mounted() {
    this.options.video.url = this.videoUrl;
  }
}
